/**
 * @generated SignedSource<<dc0a30a840443b213e81d212ee1cee48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type YesNoBlank = "blank" | "no" | "yes";
export type YesNoBlankAddressUnknown = "addressUnknown" | "blank" | "no" | "yes";
export type YesNoEtc = "etc" | "no" | "yes";
export type businessLocationQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessLocationQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly isFirstLocation: YesNoBlankAddressUnknown | null | undefined;
      readonly isStartBusinessDirectly: YesNoEtc | null | undefined;
      readonly locations: ReadonlyArray<{
        readonly address: string;
        readonly isFirstLocation: YesNoBlank;
        readonly isUnknownRelocationYear: boolean;
        readonly year: number | null | undefined;
      }> | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
  readonly getSurveyBusinessInfo: {
    readonly business: ReadonlyArray<{
      readonly adr: string | null | undefined;
      readonly ofbDt: string | null | undefined;
    }> | null | undefined;
  };
};
export type businessLocationQuery = {
  response: businessLocationQuery$data;
  variables: businessLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "bmanTin",
    "variableName": "bmanTin"
  },
  {
    "kind": "Variable",
    "name": "refundHistoryId",
    "variableName": "refundHistoryId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFirstLocation",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": "SurveyBusinessInfoOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessInfo",
        "kind": "LinkedField",
        "name": "business",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adr",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ofbDt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isStartBusinessDirectly",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUnknownRelocationYear",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessLocationQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessLocationQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "fd5f12e5366be3cbfe0946e86c77cba8",
    "id": null,
    "metadata": {},
    "name": "businessLocationQuery",
    "operationKind": "query",
    "text": "query businessLocationQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessInfo(bmanTin: $bmanTin, refundHistoryId: $refundHistoryId) {\n    business {\n      adr\n      ofbDt\n    }\n  }\n  getSurveyBusinessAnswer(bmanTin: $bmanTin, refundHistoryId: $refundHistoryId) {\n    result\n    businessAnswer {\n      isStartBusinessDirectly\n      isFirstLocation\n      locations {\n        year\n        address\n        isFirstLocation\n        isUnknownRelocationYear\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c944cd9b5083a802bf3b98bd36d48c1c";

export default node;
